export const RESPONSE_CACHE_PREFIX = 'cache-response'

export const makeResponseCacheKey = (requestHash: string): string => `${RESPONSE_CACHE_PREFIX}-${requestHash}`
